module.exports = __webpack_public_path__ + "img/icon_23years_pt.28d753a0.png";